export default __webpack_public_path__ + "static/floor1_image2-sp-e214f086a286e9a32e65c9015ce54f62.png";